import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import {
  auctionListSearchSchema,
  registrationListSearchSchema,
} from '../schemas/auction-list-search';
import { questionListSearchSchema, saleListSearchSchema } from '../schemas/sale-list-search';

const TAB =
  'text-muted-foreground hover:text-foreground inline-flex h-7 items-center rounded-md px-3 text-sm font-medium whitespace-nowrap transition-colors';
const ACTIVE = 'bg-background text-foreground shadow-sm dark:bg-input/30';

/** Auctions, Sales, Questions and Bidders: one route each, so a tab is a link with history. */
export function AuctionsNav({ storeId }: { storeId: string }) {
  const { t } = useTranslation('auctions');
  const params = { storeId };
  return (
    <div className="-mx-1 mb-4 overflow-x-auto px-1">
      <nav
        aria-label={t('nav.label')}
        className="bg-muted inline-flex h-9 items-center gap-0.5 rounded-lg p-[3px]"
      >
        <Link
          to="/s/$storeId/auctions"
          params={params}
          search={auctionListSearchSchema.parse({})}
          activeOptions={{ exact: true, includeSearch: false }}
          className={TAB}
          activeProps={{ className: ACTIVE }}
        >
          {t('nav.auctions')}
        </Link>
        <Link
          to="/s/$storeId/auctions/sales"
          params={params}
          search={saleListSearchSchema.parse({})}
          className={TAB}
          activeProps={{ className: ACTIVE }}
          data-tour="auctions.list.sales"
        >
          {t('nav.sales')}
        </Link>
        <Link
          to="/s/$storeId/auctions/questions"
          params={params}
          search={questionListSearchSchema.parse({})}
          className={TAB}
          activeProps={{ className: ACTIVE }}
          data-tour="auctions.list.questions"
        >
          {t('nav.questions')}
        </Link>
        <Link
          to="/s/$storeId/auctions/bidders"
          params={params}
          search={registrationListSearchSchema.parse({})}
          className={TAB}
          activeProps={{ className: ACTIVE }}
          data-tour="auctions.list.bidders"
        >
          {t('nav.bidders')}
        </Link>
      </nav>
    </div>
  );
}
